<template>
  <div>
    <section class="wrapper mt-32 sm:mt-40">
      <h1 class="text-center font-serif">Kontakt / Anreise</h1>
    </section>
    <section class="max-w-3xl px-4 sm:px-0 mx-auto">
      <p class="intro mt-8">
        Unser Haus liegt zentral in Aitern –
        <span
          class="
            bg-gray-100
            md:text-lg
            font-semibold
            text-gray-700
            p-1
            px-2
            rounded
          "
          >Bergstraße 14, 79677 Aitern</span
        ><br />
        Sie können uns sowohl mit dem Auto, als auch mit dem ÖPNV gut erreichen.
        Gerne holen wir Sie von der Bushaltestelle im Tal ab, wenn Sie mit ÖPNV anreisen.
      </p>
      <div class="flex justify-center">
        <a href="https://www.google.com/maps/dir//haus+morgensonne/data=!4m6!4m5!1m1!4e2!1m2!1m1!1s0x47905554470329d9:0x274f633aeea70357?sa=X&ved=2ahUKEwjjkZOdi-HzAhWHLewKHfjNDgAQ9Rd6BAgJEAQ" target="_blank">
        <button
          class="
            transition-colors
            duration-200
            ease-out
            bg-red-500
            hover:bg-red-700
            text-white
            font-bold
            text-base
            py-2
            px-4
            mt-3
            sm:mt-10
            rounded
          "
        >
          Anreise planen
        </button>
      </a>
      </div>
      <hr class="mt-12" />
      <p class="intro mt-12">
        Sie haben Fragen, oder möchten reservieren? <br />
        Schreiben Sie uns eine E-Mail oder rufen Sie uns an.
      </p>
    </section>

    <section class="max-w-4xl mx-auto mt-12 px-4 sm:px-0">
      <!-- <p class="intro mt-2">
        Wenn wir Ihr Interesse geweckt haben, dann füllen Sie einfach das
        untenstehende Formular aus und schicken es ab, oder rufen Sie uns
        einfach an
      </p> -->
      <PersonCard
        :img="getImgUrl('img/about/vermieter.jpg')"
        name="Agnes & Hanspeter Asal"
        label="Wir freuen uns auf Sie"
        mail="info@haus-morgensonne.com"
        telefon="076737043"
        class="mt-8"
      />
    </section>
  </div>
</template>

<script>
import PersonCard from '../components/PersonCard.vue'

export default {
  name: 'Contact',
  components: { PersonCard },
  methods: {
    getImgUrl(img) {
      return require('../assets/' + img)
    },
  },
}
</script>
